exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-filters .search-field {\n  margin-bottom: 2rem !important;\n}\n\n", ""]);

// exports
